import React from "react";

export default function PersonFilter({ selectedPerson, setSelectedPerson, availablePeople }) {
  return (
    <div>
      <label style={{ fontSize: 13, color: "#676879", marginRight: 8 }}>
        Filter by Person:
      </label>
      <select
        value={selectedPerson}
        onChange={(e) => setSelectedPerson(e.target.value)}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#ffffff",
          color: "#323338",
          cursor: "pointer",
          fontSize: 14,
          minWidth: 150,
        }}
      >
        <option value="all">All People</option>
        {availablePeople.map((person) => (
          <option key={person.id} value={person.id}>
            {person.name}
          </option>
        ))}
      </select>
    </div>
  );
}

